import PropTypes from 'prop-types'

const Frown = ({ width = '24', height = '24', className = '', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 41 41"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Icons/frown">
      <path
        d="M35.6668 20.5007C35.6668 28.877 28.8765 35.6673 20.5002 35.6673C12.1238 35.6673 5.3335 28.877 5.3335 20.5007C5.3335 12.1243 12.1238 5.33398 20.5002 5.33398C28.8765 5.33398 35.6668 12.1243 35.6668 20.5007Z"
        stroke="#A93C38"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.1668 27.1673C27.1668 27.1673 24.6668 23.834 20.5002 23.834C16.3335 23.834 13.8335 27.1673 13.8335 27.1673"
        stroke="#A93C38"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 15.5H15.5167"
        stroke="#A93C38"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.5 15.5H25.5167"
        stroke="#A93C38"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
)

Frown.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
}

Frown.defaultProps = {
  width: '24',
  height: '24',
  className: '',
}

export default Frown
